module.exports = __webpack_public_path__ + "img/bg.b89135de.png";